import ApiConstant from "../../constants/api.constants";
import api from "../api";
import { InvoiceCheckoutModel } from "../../models/invoice/invoice-checkout-model";
import { captureInvoiceLocation } from "./invoice-location.service";
import TokenService from "../autentication/token.service";

const GenerateNewInvoice = async (invoice: InvoiceCheckoutModel) => {
  try {
    const actor = TokenService.getUser()?.userID;
    const invoiceCreationLocation = await captureInvoiceLocation();
    if (actor !== TokenService.getUser()?.userID) {
      return { id: 0, message: 'Your session changed. Review the invoice and retry.' };
    }
    return await api
      .post(ApiConstant.generateNewInvoice, { ...invoice, invoiceCreationLocation }, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        // Do not propagate Axios config/request bodies containing device coordinates.
        return { id: 0, message: error.response?.data?.message || 'Unable to generate invoice.' };
      });
  } catch {
    console.log("error in generating invoice");
  }
};

const PaymentInvoice = async (invoiceId: number, payId: number) => {
  const payRequest: {invoiceNumber: number, paymentModeID: number} = {invoiceNumber: invoiceId, paymentModeID: payId};
  try {
    return await api
      .post(ApiConstant.paymentInvoice, payRequest, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in invoice payment");
  }
};

const OthersPayment = async (otherPaymentData: any) => {
  try {
    return await api
      .post(ApiConstant.othersPayment, otherPaymentData, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in Others payment mode");
  }
};

const InsertProductToInvoice = async (orderDetail: any) => {
  try {
    return await api
      .post(ApiConstant.insertProductToInvoice, orderDetail, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in Others payment mode");
  }
};


const InvoiceServices = {
    GenerateNewInvoice,
    PaymentInvoice,
    OthersPayment,
    InsertProductToInvoice
};

export default InvoiceServices;
